/* eslint-disable @typescript-eslint/camelcase */
import { ManagerUsersActionType, ManagerUsersActions } from '../actions/managerUsersActions';
import { createDefaultErrorAction } from '../../../actions/actionCreator';
import { put, takeLatest, call } from 'redux-saga/effects';
import { Services } from '@card/commonlib';
import { ShopFormatedType } from '../reducers/managerUsersReducers';
import { ManagerUser, Shop } from '@card/types';

type ManagerUsersAction = {
  type: string;
  error: boolean;
  payload: SaveManagerUserActionPayload;
  meta: undefined;
};

type SaveManagerUserActionPayload = {
  currentUserToEdit: ManagerUser;
  shopsToSave: ShopFormatedType[];
};

function* getManagerUsers() {
  try {
    const managerUsers: ManagerUser[] = yield call(Services.getManagerUsers);
    const shops: Shop[] = yield call(Services.getShops);
    yield put(ManagerUsersActions.getManagerUsersSuccess({ managerUsers, shops }));
  } catch (error) {
    yield put(createDefaultErrorAction(error));
  }
}

function* saveManagerUser(managerUsersActionType: ManagerUsersAction) {
  const {
    currentUserToEdit,
    shopsToSave
  }: SaveManagerUserActionPayload = managerUsersActionType.payload;
  const bodyRequest: ManagerUser = {
    email: currentUserToEdit.email,
    first_name: currentUserToEdit.first_name,
    last_name: currentUserToEdit.last_name,
    account_administrator: currentUserToEdit.account_administrator,
    id: currentUserToEdit.id,
    validated_account: currentUserToEdit.validated_account,
    shops: shopsToSave.filter((cmuShops) => cmuShops.isAssigned).map((cmuShops) => cmuShops.shop)
  };
  try {
    yield call(Services.saveManagerUser, bodyRequest);
    yield put(ManagerUsersActions.saveManagerUserSuccess());
  } catch (error) {
    yield put(createDefaultErrorAction(error));
  }
}

function* watchManagerUsersActions() {
  yield takeLatest(ManagerUsersActionType.Get, getManagerUsers);
  yield takeLatest(ManagerUsersActionType.SaveManagerUser, saveManagerUser);
}
export default watchManagerUsersActions;
